export const BASE_URL = 'https://esnaduni-api.midadworld.com/api';

export const LOCAL_STORAGE_NAME = 'esnad-local-storage';
